import { gql } from '@apollo/client';

export const UpdateSmartImportDraftMutationName = 'UpdateSmartImportDraft';

export const UPDATE_SMART_IMPORT_DRAFT_MUTATION = gql`
  mutation ${UpdateSmartImportDraftMutationName}(
    $id: ID!
    $draft: SmartImportDraftInput!
  ) {
    updateSmartImportDraft(id: $id, draft: $draft) {
      smartImport {
        id
        status
        updatedAt
        draft {
          revision
        }
      }
    }
  }
`;
